<template>
	<div class="buyerCenter">
		<!--头部banner-->

		<div class="main">
			<div class="elbox">
				<el-row>
					<el-col :span="4">
						<div class="left">
							<div class="content">
								<div class="buyerCenter">个人中心</div>
								<div class="menu">
									<el-menu :default-openeds="getOpenList" :default-active="activeItem" class="el-menu-vertical-demo" @select="handleSelect" @open="handleOpen" @close="handleClose">
										<div v-for="(father, i) in menu" :key="i">
											<el-submenu v-if="father.menuson" :index="father.index">
												<template slot="title">
													<i v-show="father.icon" :class="father.icon"></i>
													<i v-show="father.iconOther" class="iconfont" v-html="father.iconOther"></i>
													<span>{{ father.name }}</span>
												</template>
												<el-menu-item v-for="(item, i) in father.menuson" :key="i" :index="item.index">
													<span slot="title">{{ item.name }}</span>
												</el-menu-item>
											</el-submenu>

											<el-menu-item v-else :index="father.index">
												<i v-show="father.icon" :class="father.icon"></i>
												<i v-show="father.iconOther" class="iconfont" v-html="father.iconOther"></i>
												<span slot="title">{{ father.name }}</span>
											</el-menu-item>
										</div>
									</el-menu>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="20">
						<div class="right">
							<div class="content">
								<div class="Bread_crumbs flex-align-items p-15">
									<el-breadcrumb separator="/">
										<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '/buyerCenter' }">个人中心 </el-breadcrumb-item>
										<el-breadcrumb-item>{{ getcurrentitem }}</el-breadcrumb-item>
									</el-breadcrumb>
								</div>

								<div class="right_main p-15">
									<component :is="activeItem"></component>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import buyerCenter from './Module/buyerCenter'
import information from './Module/information'
import shoppingCart from './Module/shoppingCart'
import favoritesList from './Module/favoritesList'
import watchList from './Module/watchList'
import xuqiuManage from './Module/xuqiuManage'
import dongtaixinwen from './Module/dongtaixinwen'
import downList from './Module/downList'
import satsList from './Module/satsList'

export default {
	name: 'buyerCenterCom',
	components: {
		buyerCenter,
		information,
		shoppingCart,
		favoritesList,
		downList,
		watchList,
		xuqiuManage,
		dongtaixinwen,
		satsList
	},
	data() {
		return {
			tableData: [],
			itemobj: {
				// shoppingCart: '购物车',
				// buyerCenter: '我的订单',
				information: '个人信息',
				// dongtaixinwen: '动态新闻',
				// datagongao: '数据公告',
				favoritesList: '收藏列表',
				downList: '下载列表',
				satsList: '申请列表'
				// watchList: '关注列表',
				// xuqiuManage: '需求列表',
			},
			menu: [
				{
					index: 'information',
					name: '个人信息',
					iconOther: '&#xe844;'
				},
				// {
				// 	index: 'dongtaixinwen',
				// 	name: '动态新闻',
				// 	iconOther: '&#xe844;',
				// },
				// {
				// 	index: 'datagongao',
				// 	name: '数据公告',
				// 	iconOther: '&#xe847;',
				// },
				// {
				// 	index: 'xuqiuManage',
				// 	name: '需求管理',
				// 	iconOther: '&#xe844;',
				// },
				// {
				// 	index: 'buyerCenter',
				// 	name: '我的订单',
				// 	iconOther: '&#xe847;',
				// },
				// {
				// 	index: 'shoppingCart',
				// 	name: '购物车',
				// 	iconOther: '&#xe818;',
				// },

				{
					index: 'favoritesList',
					name: '收藏列表',
					icon: 'el-icon-star-on'
				},
				{
					index: 'downList',
					name: '下载列表',
					iconOther: '&#xe847;'
				},
				{
					index: 'satsList',
					name: '申请列表',
					iconOther: '&#xe721'
				}
			],
			scroll: '',
			getOpenList: ['information'],
			info: {},
			activeItem: 'information'
		}
	},
	computed: {
		getcurrentitem() {
			return this.itemobj[this.$route.query.type] ? this.itemobj[this.$route.query.type] : this.itemobj.InvestmentRules
		}
	},
	mounted() {
		//添加滚动监听器
		window.addEventListener('scroll', this.handleScroll)
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	watch: {
		'$route.query.type': {
			immediate: true,
			handler(newValue) {
				if (newValue) {
					if (Object.keys(this.itemobj).includes(newValue)) {
						this.activeItem = newValue
					} else {
						this.redirectRoute()
					}
				} else {
					this.redirectRoute()
				}
				this.tableData = this[this.$route.query.type + '_tableData']
			}
		},
		$route(newValue, oldValue) {
			this.$nextTick(() => {
				//路由发生变化，使用监听到的滚动位置
				document.body.scrollTop = this.scroll
				document.documentElement.scrollTop = this.scroll
			})
		}
	},
	methods: {
		handleTableRow(row, event, column) {
			// console.log(row, '|', event, '|', column)
		},

		handleSizeChange(pageSize) {
			console.log(`每页 ${pageSize} 条`)
			this.pageSize = pageSize
			this.currentPage = 1
		},
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
		},
		redirectRoute() {
			this.$router.push({
				name: 'buyerCenter',
				query: {
					type: 'information'
				}
			})
		},
		handleScroll() {
			this.scroll = document.documentElement.scrollTop || document.body.scrollTop
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath)
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath)
		},
		handleSelect(key, keyPath) {
			this.$router.push({
				name: 'buyerCenter',
				query: {
					type: keyPath[keyPath.length - 1]
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.buyerCenter {
	background: #eee;
	height: calc(100vh - 60px);

	.main {
		padding-top: 25px;

		.elbox {
			margin: 0 auto;
			width: 100%;

			.left {
				padding-left: 15px;

				.content {
					width: 100%;
					height: calc(100vh - 110px);
					background: #fff;
					border: 1px solid #dde4ea;

					.menu {
						height: calc(100% - 50px);
						overflow-y: auto;
						scrollbar-width: none;
						/* firefox */
						-ms-overflow-style: none;

						/* IE 10+ */
						&::-webkit-scrollbar {
							/* Chrome Safari */
							display: none;
						}
					}

					.el-menu {
						border-right: none;

						li.el-menu-item.is-active::before {
							display: inline-block;
							content: '';
							width: 5px;
							height: 15px;
							background: #3867e9;
							position: absolute;
							top: 0;
							bottom: 0;
							margin: auto;
							left: 0;
						}

						.iconfont {
							margin-right: 5px;
							width: 24px;
							text-align: center;
							font-size: 18px;
							vertical-align: middle;
							display: inline-block;
						}
					}

					.buyerCenter {
						padding-left: 40px;
						height: 50px;
						line-height: 50px;
						font-size: 20px;
						font-weight: bold;
						background: #fff;
					}

					ul.buyerCenter_item {
						overflow: hidden;
					}
				}
			}

			.right {
				padding: 0 1%;
				width: 100%;

				.content {
					height: calc(100vh - 110px);
					width: 100%;
					background: #fff;
					margin: 0 auto;
					border: 1px solid #dde4ea;
					padding-top: 0;
					overflow-y: auto;

					.Bread_crumbs {
						margin-bottom: 10px;
						height: 45px;
						border-bottom: 1px solid #e4e9ee;
						position: sticky;
						top: 0;
						z-index: 10;
						background: #fff;
					}

					.item_com {
						scrollbar-width: none;
						/* firefox */
						-ms-overflow-style: none;
						/* IE 10+ */

						&::-webkit-scrollbar {
							/* Chrome Safari */
							display: none;
						}
					}

					.title {
						margin-bottom: 10px;
					}

					.Table {
						height: 85%;

						::v-deep td.el-table_1_column_2 div:hover {
							color: #3868e9;
							cursor: pointer;
						}
					}

					.block {
						text-align: end;
					}
				}
			}
		}
	}
}
</style>